import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import Logo from '@assets/images/logo-accountpayables.svg';
import useBreakpoints from '@hooks/useBreakpoints';

import useStyles from './styles';

export interface IAccountsPayableLoader {}

const AccountsPayableLoader: FC<IAccountsPayableLoader> = () => {
  const { isTouchScreen } = useBreakpoints();
  const css = useStyles({ mobile: isTouchScreen });
  const { t } = useTranslation();

  return (
    <Grid container className={css.container}>
      <Grid item className={css.itemContainer}>
        <div className={css.logoContainer}>
          <img src={Logo} alt="BrandLogo" className={css.logo} />
        </div>
        <div className={css.textContainer}>
          <Typography variant="h2" className={css.title}>
            {t('accountsPayable.loader.title')}
          </Typography>
          <Typography variant="body1" className={css.message}></Typography>
          <CircularProgress className={css.loader} />
        </div>
      </Grid>
    </Grid>
  );
};

export default AccountsPayableLoader;
